const CLARO = 'CLARO'
const TIM = 'TIM'
const MCAFEE = 'MCAFEE'

export default {
    CLARO,
    TIM,
    MCAFEE,
}
